import { useMutation, useQuery } from '@tanstack/react-query';
import {
  logShareService,
  type CreateLogShareRequest,
  type LogShare,
} from '@/lib/log-share.service';

/**
 * Fetches a shared excerpt by code.
 *
 * `retry: false` on purpose: an unknown or unauthorised code returns 404 and no
 * amount of retrying changes that, so the page should say so immediately rather
 * than spinning three times first.
 */
export function useLogShare(code: string | undefined) {
  return useQuery<LogShare>({
    queryKey: ['log-share', code],
    queryFn: () => logShareService.get(code!),
    enabled: !!code,
    retry: false,
    // A share is immutable once written, so there is nothing to refetch for.
    staleTime: Infinity,
  });
}

export function useCreateLogShare() {
  return useMutation({
    mutationFn: (body: CreateLogShareRequest) => logShareService.create(body),
  });
}
